import React, { useState } from "react";
import NewsTable from "../components/NewsDashboard/NewsTable";
import LeftMenu from "../components/Layouts/LeftMenu";
import Header from "../components/Header";
import useAuth from "../useAuth";
import 'react-toastify/dist/ReactToastify.css';

const NewsDashboardPage = () => {
  useAuth();

  const [filterCondition, setFilterCondition] = useState((article) => article && !article.archived && !article.deleted);


  return (
    <>
      <Header />
      <LeftMenu />

      <div
        className="flex justify-center items-center"
        style={{ padding: "0 20px" }}
      >
        <NewsTable filterCondition={filterCondition} setFilterCondition={setFilterCondition} />
      </div>
    </>
  );
};

export default NewsDashboardPage;
